import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";
import { MdDownload } from "react-icons/md";

const PreviewTable = ({
  tableFileType,
  fileTypes,
  onFileTypeChange,
  previewTableData,
  indexOfFirstItem,
  currentPage,
  itemsPerPage,
  onFirstPage,
  onLastPage,
  onPrevPage,
  onNextPage,
  // Add new props for bank file download
  bankFileResponse,
  onDownloadBankFile,
  onHidePreview,
  fileNames = [], // Add fileNames prop
  onDownloadSingleFile,
}) => {
  // Map previewTableData to NonGhyup format
  const mapToNonGhyup = (data) => {
    // Example mapping: adjust keys as per NonGhyup requirements
    return data.map((row) => ({
      "1:": row.col1,
      "2:": row.col2,
      "3:": row.col3,
      "4:": row.col4,
      ":20:": row.col20,
      ":23B:": row.col23B,
      ":32A:": row.col32A,
      ":50A:": row.col50A,
      ":57A:": row.col57A,
      ":59:": row.col59,
      ":70:": row.col70,
      ":71A:": row.col71A,
      ":72:": row.col72,
    }));
  };

  // Get only the rows for the current page
  const paginatedData = previewTableData.slice(
    indexOfFirstItem,
    indexOfFirstItem + itemsPerPage
  );

  // Map paginatedData to NonGhyup format for download
  const paginatedTransformedData = mapToNonGhyup(previewTableData);

  // Handle download button click
  const handleDownload = (fileName) => {
    // Check if we have bank file response with fileName
    if (bankFileResponse && bankFileResponse.fileName) {
      // Download the actual bank file
      if (onDownloadBankFile) {
        onDownloadBankFile(bankFileResponse);
      }
    } else if (previewTableData && previewTableData.fileName) {
      // Alternative check for fileName in previewTableData
      if (onDownloadBankFile) {
        onDownloadBankFile(previewTableData);
      }
    } else {
      // Fallback to Excel export of preview data
      // const ws = XLSX.utils.json_to_sheet(paginatedTransformedData);
      // const wb = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, "NonGhyup Data");
      // XLSX.writeFile(wb, "NonGhyup_table_export.xlsx");
    }
  };

  return (
    <div className="card mt-4">
      <div className="card-body">
        <div className="d-flex justify-content-end mb-3">
          <button className="btn createButton mx-1" onClick={onHidePreview}>
            Hide Preview
          </button>
        </div>
        <div className="table-responsive">
          <table id="fileTable" className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>1:</th>
                <th>2:</th>
                <th>3:</th>
                <th>4:</th>
                <th>:20:</th>
                <th>:23B:</th>
                <th>:32A:</th>
                <th>:50A:</th>
                <th>:57A:</th>
                <th>:59:</th>
                <th>:70:</th>
                <th>:71A:</th>
                <th>:72:</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={row.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{row.col1}</td>
                  <td>{row.col2}</td>
                  <td>{row.col3}</td>
                  <td>{row.col4}</td>
                  <td>{row.col20}</td>
                  <td>{row.col23B}</td>
                  <td>{row.col32A}</td>
                  <td>{row.col50A}</td>
                  <td>{row.col57A}</td>
                  <td>{row.col59}</td>
                  <td>{row.col70}</td>
                  <td>{row.col71A}</td>
                  <td>{row.col72}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <div className="pagination">
            <Button
              variant="outlined"
              size="small"
              onClick={onFirstPage}
              disabled={currentPage === 1}
              className="me-2"
            >
              First
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={onPrevPage}
              disabled={currentPage === 1}
              className="me-2"
            >
              Prev
            </Button>
            <span className="mx-2 align-self-center">
              Page {currentPage} of{" "}
              {Math.ceil(previewTableData.length / itemsPerPage)}
            </span>
            <Button
              variant="outlined"
              size="small"
              onClick={onNextPage}
              disabled={
                currentPage ===
                Math.ceil(previewTableData.length / itemsPerPage)
              }
              className="me-2"
            >
              Next
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={onLastPage}
              disabled={
                currentPage ===
                Math.ceil(previewTableData.length / itemsPerPage)
              }
            >
              Last
            </Button>
          </div>
        </div>
        {/* <div className="row justify-content-center align-items-center mt-3">
          <div className="col-12 text-center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
              sx={{
                backgroundColor: "var(--theme-color)",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "var(--theme-color)",
                  opacity: 0.9,
                },
                "&:disabled": {
                  backgroundColor: "#6c757d",
                },
              }}
            >
               Download {bankFileResponse?.fileName ? 'Bank File' : 'Preview Data'} 
              Download Bank File
            </Button>
          </div>
        </div> */}
        {/* File List Section - Display below the table */}
        {fileNames && fileNames.length > 0 && (
          <div className="mt-4 pt-3 border-top">
            <h6 className="mb-3" style={{ fontWeight: 600 }}>
              Download Bank Files
            </h6>
            <div className="row">
              {fileNames.map((fileName, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6 col-lg-6 mb-3"
                  onClick={() =>
                    onDownloadSingleFile && onDownloadSingleFile(fileName)
                  }
                  role="button"
                >
                  <div
                    className="d-flex align-items-center justify-content-between p-3 border rounded"
                    style={{ backgroundColor: "#f8f9fa" }}
                  >
                    <div
                      className="flex-grow-1 me-2"
                      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      <span
                        className="text-truncate d-block fileName"
                        title={fileName}
                      >
                        {fileName}
                      </span>
                    </div>
                    <IconButton
                      color="primary"
                      size="small"
                      sx={{
                        color: "var(--theme-color)",
                        "&:hover": {
                          backgroundColor: "rgba(0, 123, 255, 0.1)",
                        },
                      }}
                      title={`Download ${fileName}`}
                    >
                      <MdDownload />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreviewTable;
